import { HttpClient, JSON_STRING ,MHTTPCL } from "../../../services/http/http-client";

export const CONTACTS_URL = '/contacts.pl';
export const CONTACT_GROUP_SECTION = 'groups';

export const ContactGroupsService = {
  getNotContactGroupsPage:(group_id,tableID,startrow)=>MHTTPCL.post(CONTACTS_URL,{
    section: 'groups',
    action: 'not_group_contacts_page',
    tableID:tableID,
    group_id:group_id,
    startrow:startrow,
    output:JSON_STRING
  }),

  getContactGroupsPage:(group_id,tableID,startrow)=>MHTTPCL.post(CONTACTS_URL,{
    section: 'groups',
    action: 'group_contacts_page',
    tableID:tableID,
    group_id:group_id,
    startrow:startrow,
    output:JSON_STRING
  }),

  getContactGroups: () => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION
  }),
  deleteContactGroup: (group_id) => HttpClient.post(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION,
    action: 'delete_group',
    group_id
  }),
  getContactGroupsDetails: (group_id) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION,
    action: 'group_details',
    group_id
  }),
  getContactGroupCSV: (group_id) => {
    return HttpClient.get(CONTACTS_URL, {
      section: 'import_export',
      action: 'export_groups_as_csv',
      group_id
    }, {
        responseType: 'blob'
      });
  },
  getContactGroupEmails: (group_id) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION,
    action: 'group_contacts_mail',
    group_id
  }),
  deleteGroupContact: (contact_relation_id) => HttpClient.post(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION,
    action: 'remove_group_contact',
    contact_relation_id
  }),
  getGroupContactModal: (group_id) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION,
    action: 'unrelated_group_contacts',
    group_id
  }),
  searchContactForAddGroupContact: (searchKeys) => HttpClient.get(CONTACTS_URL, {
    section: CONTACT_GROUP_SECTION,
    action: 'search_unrelated_group_contacts',
    ...searchKeys
  }),
  addContactsToGroup: (group_id, selectedContactsIDarray) => {
    let contactsStatusArray = selectedContactsIDarray.map(row => 1);
    return HttpClient.post(CONTACTS_URL, {
      section: CONTACT_GROUP_SECTION,
      action: 'relate_group_contacts',
      external_id: group_id,
      external_table: 'groups',
      contacts: selectedContactsIDarray.join(),
      contacts_id: contactsStatusArray.join(),
      output: JSON_STRING
    });
  },
  addNewContactGroup: (params) => {
    return HttpClient.post(CONTACTS_URL, {
      section: CONTACT_GROUP_SECTION,
      action: 'add_new_group',
      ...params
    });
  }
}